function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { PropTypes } from 'prop-types';
import { Icon } from '@unite-us/ui';
import _ from 'lodash';
import classNames from 'classnames';
import OverlaySpinner from '../spinners/OverlaySpinner';
import Overlay from './Overlay';
import './Dialog.scss';
var Title = function Title(_ref) {
  var title = _ref.title,
    close = _ref.close,
    removeCloseIcon = _ref.removeCloseIcon,
    titleStyles = _ref.titleStyles,
    dataTestElementClose = _ref.dataTestElementClose,
    titleClass = _ref.titleClass;
  if (!title) {
    return null;
  }
  if (removeCloseIcon) {
    return /*#__PURE__*/React.createElement("div", {
      className: "title",
      style: _objectSpread({}, titleStyles)
    }, title);
  }
  return /*#__PURE__*/React.createElement("div", {
    style: _objectSpread({}, titleStyles),
    className: "title title-closeable ",
    "data-test-element": dataTestElementClose
  }, /*#__PURE__*/React.createElement("span", {
    className: "".concat(titleClass)
  }, title), /*#__PURE__*/React.createElement(Icon, {
    className: "h-3 w-3 stroke-current stroke-1 fill-current text-text-blue",
    icon: "IconCross",
    onClick: close
  }));
};
Title.propTypes = {
  titleClass: PropTypes.string,
  title: PropTypes.string,
  titleStyles: PropTypes.object,
  close: PropTypes.func.isRequired,
  removeCloseIcon: PropTypes.bool.isRequired,
  dataTestElementClose: PropTypes.string.isRequired
};
Title.defaultProps = {
  title: null,
  titleClass: '',
  titleStyles: {}
};
var Footer = function Footer(_ref2) {
  var actions = _ref2.actions,
    footerStyles = _ref2.footerStyles;
  if (!actions) {
    return null;
  }
  if (_.isArray(actions)) {
    return /*#__PURE__*/React.createElement("div", {
      className: "actions"
    }, actions.map(function (a, i) {
      return /*#__PURE__*/React.createElement("span", {
        key: i,
        className: "action-item"
      }, a);
    }));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "actions",
    style: _objectSpread({}, footerStyles)
  }, actions);
};
Footer.propTypes = {
  actions: PropTypes.node,
  footerStyles: PropTypes.object
};
Footer.defaultProps = {
  actions: null,
  footerStyles: {}
};
var Dialog = /*#__PURE__*/function (_React$Component) {
  function Dialog(props) {
    var _this;
    _classCallCheck(this, Dialog);
    _this = _callSuper(this, Dialog, [props]);
    _this.onRequestClose = _this.onRequestClose.bind(_this);
    _this.onOverlayClick = _this.onOverlayClick.bind(_this);
    _this.getDialogClass = _this.getDialogClass.bind(_this);
    _this.openDialog = _this.openDialog.bind(_this);
    _this.closeDialog = _this.closeDialog.bind(_this);
    _this.onEscape = _this.onEscape.bind(_this);
    _this.state = {
      open: false,
      resolver: function resolver() {
        return null;
      }
    };
    return _this;
  }
  _inherits(Dialog, _React$Component);
  return _createClass(Dialog, [{
    key: "onEscape",
    value: function onEscape(e) {
      if (e.key === 'Escape' && !this.props.modal) {
        this.onRequestClose();
      }
    }
  }, {
    key: "onRequestClose",
    value: function onRequestClose() {
      if (_.isFunction(this.props.onRequestClose)) {
        return this.props.onRequestClose();
      }
      return this.closeDialog();
    }
  }, {
    key: "onOverlayClick",
    value: function onOverlayClick() {
      if (!this.props.modal) {
        this.onRequestClose();
      }
    }
  }, {
    key: "getDialogClass",
    value: function getDialogClass() {
      return classNames({
        dialog: true,
        open: this.state.open
      });
    }
  }, {
    key: "openDialog",
    value: function openDialog() {
      var _this2 = this;
      document.addEventListener('keyup', this.onEscape);
      return new Promise(function (resolve) {
        _this2.setState({
          resolver: resolve
        }, function () {
          return _this2.setState({
            open: true
          });
        });
      });
    }
  }, {
    key: "closeDialog",
    value: function closeDialog() {
      var _this3 = this;
      var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'dismiss';
      document.removeEventListener('keyup', this.onEscape);
      this.setState({
        open: false
      }, function () {
        return _this3.state.resolver(action);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        actions = _this$props.actions,
        children = _this$props.children,
        id = _this$props.id,
        removeCloseIcon = _this$props.removeCloseIcon,
        spinnerShow = _this$props.spinnerShow,
        spinnerText = _this$props.spinnerText,
        spinnerDescription = _this$props.spinnerDescription,
        size = _this$props.size,
        titleStyles = _this$props.titleStyles,
        footerStyles = _this$props.footerStyles,
        title = _this$props.title,
        dialogContentStyles = _this$props.dialogContentStyles,
        showBorderRadius = _this$props.showBorderRadius,
        dataTestElementClose = _this$props.dataTestElementClose,
        className = _this$props.className,
        customSize = _this$props.customSize,
        titleClass = _this$props.titleClass,
        dataId = _this$props['data-testid'];
      if (!this.state.open) return null;
      return /*#__PURE__*/React.createElement("div", {
        id: id,
        tabIndex: -1,
        className: classNames(className, "".concat(this.getDialogClass()), customSize ? 'custom' : size),
        "data-testid": dataId
      }, /*#__PURE__*/React.createElement(Overlay, {
        open: this.state.open,
        autoLockScrolling: true,
        onClick: this.onOverlayClick
      }), /*#__PURE__*/React.createElement("div", {
        className: classNames('dialog-paper', {
          'dialog-radius': showBorderRadius
        }),
        style: customSize
      }, /*#__PURE__*/React.createElement(OverlaySpinner, {
        show: spinnerShow,
        text: spinnerText,
        description: spinnerDescription
      }), /*#__PURE__*/React.createElement(Title, {
        title: title,
        close: this.onRequestClose,
        removeCloseIcon: removeCloseIcon,
        titleStyles: titleStyles,
        dataTestElementClose: dataTestElementClose,
        titleClass: titleClass
      }), /*#__PURE__*/React.createElement("div", {
        className: "dialog-content",
        style: _objectSpread({}, dialogContentStyles)
      }, children), /*#__PURE__*/React.createElement(Footer, {
        footerStyles: footerStyles,
        actions: actions
      })));
    }
  }]);
}(React.Component);
export { Dialog as default };
Dialog.propTypes = {
  titleClass: PropTypes.string,
  className: PropTypes.string,
  actions: PropTypes.node,
  children: PropTypes.node.isRequired,
  id: PropTypes.string,
  modal: PropTypes.bool,
  onRequestClose: PropTypes.func,
  removeCloseIcon: PropTypes.bool,
  size: PropTypes.oneOf(['mini', 'small', 'normal', 'large', 'jumbo', 'full']),
  spinnerShow: PropTypes.bool,
  spinnerText: PropTypes.string,
  spinnerDescription: PropTypes.string,
  titleStyles: PropTypes.object,
  footerStyles: PropTypes.object,
  title: PropTypes.node,
  dialogContentStyles: PropTypes.object,
  showBorderRadius: PropTypes.bool,
  dataTestElementClose: PropTypes.string,
  customSize: PropTypes.shape({
    width: PropTypes.string,
    height: PropTypes.string
  }),
  'data-testid': PropTypes.string
};
Dialog.defaultProps = {
  titleClass: '',
  className: '',
  actions: null,
  footerStyles: {},
  id: '',
  modal: false,
  onRequestClose: null,
  removeCloseIcon: false,
  size: 'normal',
  spinnerDescription: '',
  spinnerShow: false,
  spinnerText: 'Submitting...',
  title: null,
  titleStyles: {},
  dialogContentStyles: {},
  showBorderRadius: false,
  dataTestElementClose: 'modal-close',
  customSize: null,
  'data-testid': undefined
};
//# sourceMappingURL=Dialog.js.map